module.exports = __webpack_public_path__ + "img/k-open-close-home-icon.11261361.png";